export default __webpack_public_path__ + "static/media/box-in-logo-green.e4e798a5.svg";